export function getPortalHostWithoutSpecialCaracters(host: string): string {
  const replacedHost = host?.replace(/[^a-zA-Z0-9]/g, '');
  return replacedHost?.charAt(0).toUpperCase() + replacedHost?.slice(1);
}
